import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

const white = constants.colors.ui.white[600];
const blue = constants.colors.ui.core[600];

export const asteriskBlue: CSSObject = {
  color: blue,
};

export const dropdownCss: CSSObject = {
  maxWidth: "288px",
  ul: {
    width: "max-content",
  },
};

export const sectionCss: CSSObject = {
  margin: "-2em",
  padding: "2em",
};

export const checkBoxAndTooltipContainerCss: CSSObject = {
  display: "flex",
  alignItems: "center",
};

export const rowCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
  paddingBottom: "1em",
  backgroundColor: white,
  [breakpoint.upTo("md")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
};

export const checkBoxLabelCss: CSSObject = {
  width: "auto",
  marginLeft: "-1rem",
};

export const toggleButtonCss: CSSObject = {
  width: "auto",
  padding: "12px 16px",
};
